/**
* @name: account-tree-show-panel
* @author: weiyong
* @date: 2023-02-21 23:47
* @description：account-tree-show-panel
* @update: 2023-02-21 23:47
*/
<template>
  <div class="account-tree-show-panel-gongxu wh100b">
    <div class="panel-title">
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="accountTreeList" :tab="t('帐套信息')"></a-tab-pane>
      </a-tabs>
    </div>
    <div class="top-cell">
      <a-tree
          :showLine="true"
          @select="selectAccount"
          v-model:expandedKeys="expandedKeys"
          v-model:selectedKeys="selectedKeys"
          :tree-data="orgTreeList"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useAccountShowTree} from "../hooks/useAccountShowTree";
import {Tree as aTree} from "ant-design-vue";
import {ref} from 'vue';
import {useI18n} from "vue-i18n";
const activeKey=ref('accountTreeList');
const {t} = useI18n();
const props = defineProps({
  multiple: {},
  alreadySelUsers: {},
});

const emits = defineEmits(['selItemRecord']);
const {
  orgTreeList,
  expandedKeys,
  selectAccount,
  selectedKeys
} = useAccountShowTree(emits);

</script>

<style type="text/css" lang="less">
.account-tree-show-panel-gongxu {
  height: calc(100% - 48px);

  .top-cell {
    height: 422px;
    overflow: auto;
    padding: 12px 0 12px 20px;
  }
}

</style>
